"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _default = function _default(obj, idAttribute) {
  return {
    id: obj[idAttribute],
    get: function get(propertyName) {
      return obj[propertyName];
    },
    toJSON: function toJSON() {
      return (0, _extends2.default)({}, obj);
    }
  };
};

exports.default = _default;
module.exports = exports.default;